import { createSlice } from '@reduxjs/toolkit';
import getEvent from '../services/processEvents';

/* Creating a slice of the state for stuff related to the events. */
const totalDeliveryValueSlice = createSlice({
  name: 'totalDeliveryValue',
  initialState: {
    type: null
  },
  reducers: {
    fireTdvEvent: (state, action) => {
      state.type = 'tdv';
      const datasets = action.payload.datasets;
      const eventLabel = action.payload.event;
      state.parameters = getEvent(eventLabel, datasets);
      state.event = action.payload.event;
    },
    trackingEvent: (state, action) => {
      state.parameters = action.payload.parameters;
      state.isFetchingEvent = true;
    },
    trackingEventError: (state) => {
      state.parameters = null;
      state.isFetchingEvent = false;
    },
    trackingEventFulfilled: (state) => {
      state.parameters = null;
      state.event = null;
      state.type = null;
      state.isFetchingEvent = false;
    }
  },
});

export default totalDeliveryValueSlice;
